export default __webpack_public_path__ + "static/kompakte-kleine-boge-kompressoren-9281e32d4c7c56aafed29771a2db4cb8.png";